import { render } from "./DetailGangModal.vue?vue&type=template&id=7578dc57&scoped=true"
import script from "./DetailGangModal.vue?vue&type=script&lang=js"
export * from "./DetailGangModal.vue?vue&type=script&lang=js"

import "./DetailGangModal.vue?vue&type=style&index=0&id=7578dc57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7578dc57"]])

export default __exports__